import { render, staticRenderFns } from "./ExpertsList.vue?vue&type=template&id=2047b90e&scoped=true"
import script from "./ExpertsList.vue?vue&type=script&lang=js"
export * from "./ExpertsList.vue?vue&type=script&lang=js"
import style0 from "./ExpertsList.vue?vue&type=style&index=0&id=2047b90e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2047b90e",
  null
  
)

export default component.exports